<template>
  <div>
    <site-header />
    <main class="shop-page">
      <section class="shop-hero">
        <p>Men's Shop</p>
        <h1>{{ activeCategory || 'All Menswear' }}</h1>
        <span>{{ total }} styles</span>
      </section>

      <section class="shop-layout">
        <aside class="filters-panel">
          <h2>Categories</h2>
          <button :class="{ active: !activeCategory }" @click="selectCategory('')">All</button>
          <button
            v-for="category in categories"
            :key="category"
            :class="{ active: activeCategory === category }"
            @click="selectCategory(category)"
          >
            {{ category }}
          </button>
        </aside>
        <div class="shop-results">
          <div class="sort-row">
            <span>GearPulse men's essentials</span>
            <select v-model="sortMode">
              <option value="featured">Featured</option>
              <option value="low">Price low to high</option>
              <option value="high">Price high to low</option>
            </select>
          </div>
          <div v-if="loading" class="loading-state">Loading products...</div>
          <div v-else-if="sortedProducts.length" class="product-grid">
            <product-card v-for="product in sortedProducts" :key="product.id" :product="product" />
          </div>
          <div v-else class="inline-empty">No products found in this category.</div>
          <div v-if="total > pageSize" class="pagination-wrap">
            <el-pagination
              background
              layout="prev, pager, next"
              :current-page="pageNum"
              :page-size="pageSize"
              :total="total"
              @current-change="changePage"
            />
          </div>
        </div>
      </section>
    </main>
    <site-footer />
  </div>
</template>

<script>
import SiteHeader from '@/components/SiteHeader.vue'
import SiteFooter from '@/components/SiteFooter.vue'
import ProductCard from '@/components/ProductCard.vue'
import { categories } from '@/data/products'
import { queryGoods } from '@/api/goods'

export default {
  name: 'ProductList',
  components: { SiteHeader, SiteFooter, ProductCard },
  data() {
    return {
      categories,
      products: [],
      total: 0,
      pageNum: 1,
      pageSize: 12,
      sortMode: 'featured',
      loading: false
    }
  },
  computed: {
    activeCategory() {
      return this.$route.query.category || ''
    },
    sortedProducts() {
      const next = [...this.products]
      if (this.sortMode === 'low') return next.sort((a, b) => a.price - b.price)
      if (this.sortMode === 'high') return next.sort((a, b) => b.price - a.price)
      return next
    }
  },
  watch: {
    '$route.query.category'() {
      this.pageNum = 1
      this.loadProducts()
    }
  },
  created() {
    this.loadProducts()
  },
  methods: {
    async loadProducts() {
      this.loading = true
      try {
        const res = await queryGoods({
          num: this.pageNum,
          size: this.pageSize,
          categoryType: this.activeCategory
        })
        this.products = res.list
        this.total = res.total
      } finally {
        this.loading = false
      }
    },
    selectCategory(category) {
      this.$router.push({ path: '/items', query: category ? { category } : {} })
    },
    changePage(page) {
      this.pageNum = page
      this.loadProducts()
    }
  }
}
</script>
